import axios from 'axios'
import appconst from './appconst'
import Vue from 'vue'
import {Modal} from 'ant-design-vue';

// axios.defaults.withCredentials = true;
const ajax = axios.create({
    baseURL: appconst.remoteServiceBaseUrl,
    timeout: 3000000,
    withCredentials: true
    // baseURL:'http://192.168.1.140:4424',
    // timeout: 30000
});
ajax.interceptors.request.use(function (config) {
    if (!!window.abp.auth.getToken()) {
        config.headers.common["X-SoilInfo-Token"] = window.abp.auth.getToken();
    }
    config.headers.common[".AspNetCore.Culture"] = window.abp.utils.getCookieValue("Abp.Localization.CultureName");
    config.headers.common["Abp.TenantId"] = window.abp.multiTenancy.getTenantIdCookie();
    return config;
}, function (error) {

    return Promise.reject(error);
});
let vm = new Vue({});
ajax.interceptors.response.use((respon) => {
    return respon
}, (error) => {
    let errorWin: any = null
    // let needRedirect: boolean = false;
    if (!!error.response && !!error.response.data.error && !!error.response.data.error.message && error.response.data.error.details) {
        errorWin = Modal.error({title: error.response.data.error.message, content: error.response.data.error.details})
    } else if (!!error.response && !!error.response.data.errno && !!error.response.data.errmsg) {
        let content = error.response.data.errmsg
        if (error.response.status == 401) {
            // needRedirect = true; //授权失败,需要重新登录
            // content = '登录信息失效，即将跳转到重新登录页';
            vm.$message.error('登录信息失效，即将跳转到重新登录页');
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }
        errorWin = Modal.error({
            title: '请求失败!',
            content: content
        })
    } else if (!!error.response && !!error.response.data.error && !!error.response.data.error_description) {
        let content = error.response.data.error.error_description
        content = '输入的用户名或密码无效';
        errorWin = Modal.error({
            title: '登录失败!',
            content: content
        })
    } else if (!error.response) {
        errorWin = Modal.error({title: '提示', content: '请求数据超时,请稍后再试!'});
    }
    if (errorWin) {
        errorWin.destroy();
    }
    return Promise.reject(error);
})
export default ajax;
